import { useRouter } from 'next/router'

export const useUpdateQueryParams = () => {
  const router = useRouter()

  const updateQueryParams = (query: Record<string, string | undefined>, resetScrollPosition = false) => {
    const [asPathRoot, asPathQuery = ''] = router.asPath.split('?')
    const params = new URLSearchParams(asPathQuery)

    Object.entries(query).forEach(([key, value]) => {
      if (value && value !== 'undefined') {
        params.set(key, value)
      } else {
        params.delete(key)
      }
    })
    const queryString = params.toString()
    const asPath = queryString ? `${asPathRoot}?${queryString}` : asPathRoot
    // Use replace to update URL in-place (preserves on refresh); shallow avoids full page reload
    router.replace(asPath, asPath, { shallow: true })

    if (resetScrollPosition) {
      const obj = document.getElementById('mainContainer')
      if (obj) {
        obj.scrollTo({
          top: 0,
          behavior: 'smooth', // for smoothly scrolling
        })
      }
    }
  }

  return { updateQueryParams }
}
